export enum FieldMaskType {
  none = 0,
  cpf = 1,
  cnpj = 2,
  twoDecimalPlaces = 3,
  fourDecimalPlaces = 4,
  eightDecimalPlaces = 5,
  phoneNumber = 6
}
